module.exports = __webpack_public_path__ + "img/2_ToDust.422e2460.jpg";